<template>
  <div class="wrap-symptom">
    <div class="tab-symptom">
      <div class="tab-box">
        <div
          class="tab-item"
          :class="{ active: !symptomListVisible }"
          @click="symptomListVisible = false"
        >
          人体部位查找
        </div>
        <div
          class="tab-item"
          :class="{ active: symptomListVisible }"
          @click="symptomListVisible = true"
        >
          症状列表查找
        </div>
      </div>
    </div>
    <!-- 症状分类 -->
    <div
      v-if="symptomListVisible"
      class="container"
      :class="searchVisible ? 'bg2' : ''"
    >
      <div class="close-icon" @click="closeHandle">
        <span class="el-icon-close"></span>
      </div>
      <!-- 左侧症状菜单 -->
      <div class="symptom-left">
        <div class="title">
          <img src="/images/preloader/icon-symptom.png" alt="" />
          <span>查症状</span>
        </div>
        <div ref="menuList" class="list-wrap">
          <ul class="list">
            <li
              v-for="(item, index) in symptomList"
              :key="index"
              :class="
                curSelectSymptomIndex === index && searchKey.length === 0
                  ? 'active'
                  : ''
              "
              @click="selectSymptom(index)"
            >
              {{ item.typeName }}
            </li>
          </ul>
        </div>
        <div class="btn-group">
          <div style="margin: 0 20px 0 0;" @click="scrollHandle('up')">
            <img src="/images/preloader/icon-up.png" alt="" /><span>上翻</span>
          </div>
          <div @click="scrollHandle('down')">
            <img src="/images/preloader/icon-down.png" alt="" /><span
              >下翻</span
            >
          </div>
        </div>
      </div>

      <!-- 中间症状选项 -->
      <div class="symptom-middle">
        <div class="btn-group-top">
          <div @click="searchSwitch">
            <img src="/images/preloader/icon_foot_search.png" alt="" /><span
              >拼音查找</span
            >
          </div>
        </div>
        <div class="content">
          <ul v-if="pinyinSearchList.length > 0" class="list">
            <li
              v-for="(item, index) in pinyinSearchList"
              :key="index"
              @click="selectSymptomItem(item.detailId)"
            >
              {{ item.detailName }}
            </li>
          </ul>
          <noContent v-else-if="searchKey.length > 0"></noContent>

          <ul v-else-if="curSymptomChilds.length > 0" class="list">
            <li
              v-for="(item, index) in curSymptomChilds"
              :key="index"
              @click="selectSymptomItem(item.detailId)"
            >
              {{ item.detailName }}
            </li>
          </ul>

          <noContent v-else></noContent>
        </div>

        <div class="btn-group">
          <div class="renxing-btn" @click="symptomListVisible = false">
            <img src="/images/preloader/icon-renxing.png" alt="" /><span
              >人体部位查找</span
            >
          </div>
          <div @click="closeHandle">
            <img src="/images/preloader/icon_foot_close.png" alt="" /><span
              >关闭</span
            >
          </div>
          <!-- <div @click="searchSwitch"><img src="/images/preloader/icon_foot_search.png" alt=""><span>拼音查找</span></div> -->
        </div>
      </div>

      <!-- 右侧拼音查找 -->
      <div v-show="searchVisible" class="symptom-right">
        <div class="title">拼音查找</div>
        <input v-model="searchKey" class="search-input" disabled type="text" />
        <div class="letter-wrap">
          <div
            v-for="(item, index) in letterArr"
            :key="index"
            class="letter"
            @click="inputLetter(item)"
          >
            {{ item }}
          </div>
          <div class="letter" style="flex:1;" @click="deleteLetter">
            <img src="/images/preloader/icon_pingyin_deletion.png" alt="" />
            <span>回删</span>
          </div>
        </div>
        <div class="btn-group">
          <div @click="searchSwitch">
            <img src="/images/preloader/icon_foot_packup.png" alt="" /><span
              >收起</span
            >
          </div>
          <div class="btn-right" @click="closeHandle">
            <img src="/images/preloader/icon_foot_close.png" alt="" /><span
              >关闭</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 人形部位 -->
    <div v-if="!symptomListVisible" class="person-symptom">
      <div class="close-icon" @click="closeHandle">
        <span class="el-icon-close"></span>
      </div>
      <div class="person-symptom-left">
        <div class="person-wrap">
          <!-- 年龄段选择 -->
          <div class="btn-group btn1">
            <div
              v-for="(item, index) in personTypeArr"
              :key="index"
              :class="personType === item.value ? 'active' : ''"
              @click="changePerson('personType', item.value)"
            >
              {{ item.label }}
            </div>
          </div>
          <!-- 性别选择 -->
          <div class="btn-group btn2">
            <div
              v-for="(item, index) in genderArr"
              :key="index"
              :class="gender === item.value ? 'active' : ''"
              @click="changePerson('gender', item.value)"
            >
              {{ item.label }}
            </div>
          </div>
          <!-- 正背面选择 -->
          <div class="btn-group2 btn3">
            <div
              v-for="(item, index) in personFaceArr"
              :key="index"
              :class="faceType === item.value ? 'active' : ''"
              @click="changePerson('faceType', item.value)"
            >
              {{ item.label }}
            </div>
          </div>
          <!-- tip -->
          <div class="tip">请点选人体部位查找症状</div>
          <!-- 人形图 -->
          <div class="person">
            <img
              :src="
                './images/preloader/person/' + personData[curSelectGroup]['img']
              "
              class="wh"
              :class="personType === 2 ? 'wh70' : 'wh90'"
              alt=""
            />
            <svg
              class="wh"
              :viewBox="personData[curSelectGroup]['viewBox']"
              :class="personType === 2 ? 'wh70' : 'wh90'"
            >
              <path
                v-for="(item, key, index) in personData[curSelectGroup]['path']"
                :key="index"
                class="cls-1"
                :d="item"
                @click="clickPerson(key)"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="person-symptom-right">
        <!-- 人形部位症状内容 -->
        <div class="symptomPop">
          <div class="content">
            <!-- 有数据 -->
            <template
              v-if="personSymptomData && personSymptomData['symptomJson']"
            >
              <div
                v-for="(item, index) in personSymptomData['symptomJson']"
                :key="index"
                class="symptom-wrap"
              >
                <div class="symptom-cate">{{ item.typeName }}</div>
                <div class="symptom-list">
                  <div
                    v-for="(item2, index2) in item['detailDTOList']"
                    :key="index2"
                    class="symptom-li"
                    @click="selectSymptomItem(item2.detailId)"
                  >
                    {{ item2.detailName }}
                  </div>
                </div>
              </div>
            </template>
            <!-- 无数据 -->
            <template v-else>
              <noContent
                img-url="empty.png"
                msg="请点选人体部位查找症状"
              ></noContent>
            </template>
          </div>
        </div>
        <!-- 按钮组 -->
        <div class="btn-group btn-person">
          <div class="btn-left" @click="symptomListVisible = true">
            <img src="/images/preloader/icon-list.png" alt="" /><span
              >症状列表查找</span
            >
          </div>
          <div class="btn-right" @click="closeHandle">
            <img src="/images/preloader/icon_foot_close.png" alt="" /><span
              >关闭</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 详情 -->
    <div v-if="detailVisible" class="symptom-detail-mask">
      <div class="close-icon" @click="closeHandle">
        <span class="el-icon-close"></span>
      </div>
      <div class="symptom-detail">
        <div class="title">{{ symptomDetailList.detailName }}</div>
        <div class="content">
          <div v-if="symptomDetailList.description" class="d-flex">
            <div class="description">{{ symptomDetailList.description }}</div>

            <div v-if="symptomDetailList.processJson" class="step-info">
              <div class="step-block">
                <div
                  v-for="(item, i) in JSON.parse(symptomDetailList.processJson)"
                  :key="item.name + i"
                  class="step-item"
                >
                  <div class="step-item-sort">{{ i + 1 }}</div>
                  <div class="step-item-title">{{ item.name }}</div>
                  <div
                    v-for="e in item.process"
                    :key="e.poiId"
                    class="step-item-content"
                  >
                    <span>
                      {{ e.name }}
                    </span>
                    <span>
                      {{ floorMapping[e.floor] || e.floor }}
                    </span>
                    <el-button type="primary" size="default" @click="jumpFn(e)"
                      >去这里</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <noContent v-else></noContent>
        </div>
        <div class="btn-group">
          <div
            class="guahao"
            @click="guahaoHandle"
            v-if="!symptomDetailList.processJson"
          >
            <span>去挂号</span>
          </div>
          <div style="margin: 0 0 0 40px;" @click="closeHandle">
            <img src="/images/preloader/icon_foot_close.png" alt="" /><span
              >关闭</span
            >
          </div>
          <div
            style="margin: 0 0 0 40px;"
            @click="detailVisible = !detailVisible"
          >
            <img src="/images/preloader/icon-left.png" alt="" /><span
              >返回</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import personData from "./personData.js"; // 人形图数据
import noContent from "@/components/no-content";

export default {
  components: {
    noContent
  },
  props: {},
  data() {
    return {
      searchVisible: false, // 拼音搜索显示状态
      detailVisible: false, // 症状详情窗口显示状态
      searchKey: "", // 拼音搜索关键字
      pinyinSearchList: [], // 拼音搜索结果
      symptomList: [], // 症状分类列表
      symptomDetailList: {}, // 症状详情
      curSelectSymptomIndex: 0, // 当前选择症状分类下标

      symptomListVisible: false,
      symptomPersonVisible: true,

      /** 人形导诊 */
      personTypeArr: [
        { label: "儿童", value: 2 },
        { label: "成人", value: 1 }
      ],
      genderArr: [
        { label: "男", value: 1 },
        { label: "女", value: 2 }
      ],
      personFaceArr: [
        { label: "正面", value: 1 },
        { label: "背面", value: 2 }
      ],
      personType: 1, // 成人/儿童
      gender: 1, // 性别
      faceType: 1, // 正反面
      humanPart: 1, // 部位
      personData: personData, // 人形数据
      personSymptomDataObj: {}, // 人形症状数据对象（存放已查询的部位症状数据）
      personSymptomData: null // 人形症状数据
    };
  },
  computed: {
    // 地图楼层映射
    floorMapping() {
      return this.$store.getters["nav/floorMapping"];
    },
    // 建筑信息
    buildInfo: {
      get() {
        return this.$store.state.nav.buildInfo;
      },
      set(val) {
        this.$store.commit("nav/set_buildInfo", val);
      }
    },
    // 症状分类子项
    curSymptomChilds() {
      if (this.symptomList[this.curSelectSymptomIndex]) {
        return this.symptomList[this.curSelectSymptomIndex].detailDTOList;
      } else {
        return [];
      }
    },
    // 当前人形选项组合
    curSelectGroup() {
      return (
        String(this.personType) + String(this.gender) + String(this.faceType)
      );
    },
    ...mapState("app", ["letterArr"])
  },
  watch: {
    searchKey(val) {
      if (val.length > 0) {
        this.pinyinSearch(val);
      } else {
        this.pinyinSearchList = [];
      }
    },
    detailVisible(val) {
      if (!val) {
        this.symptomDetailList = {};
      }
    }
  },
  async created() {
    let symptomRes = await this.getSymptomList();
    console.log(symptomRes.list);
    symptomRes.list.forEach(item => {
      if (!item.detailDTOList) {
        item.detailDTOList = [];
      }
    });
    this.symptomList = symptomRes.list;
  },
  mounted() {},
  methods: {
    ...mapActions("nav", [
      // 调用定时器
      "enterSaver"
    ]),
    jumpFn(e) {
      this.$emit("daozhen", e);
    },
    // 选择症状分类
    selectSymptom(index) {
      this.searchKey = "";
      this.curSelectSymptomIndex = index;
    },
    // 选择症状
    selectSymptomItem(detailId) {
      this.getSymptomdetail(detailId);
      this.detailVisible = true;
    },
    // 上翻下翻
    scrollHandle(type) {
      console.log(this.$refs.menuList.scrollTop);
      let scrollTop = this.$refs.menuList.scrollTop;
      if (type === "up") {
        this.$refs.menuList.scrollTop = scrollTop - 600;
      } else {
        this.$refs.menuList.scrollTop = scrollTop + 600;
      }
    },
    // 拼音搜索开关
    searchSwitch() {
      this.searchVisible = !this.searchVisible;
    },
    // 输入字母
    inputLetter(letter) {
      this.searchKey += letter;
    },
    // 删除字母
    deleteLetter() {
      if (this.searchKey.length > 0) {
        console.log(123123);
        this.searchKey = this.searchKey.substr(0, this.searchKey.length - 1);
      }
    },
    // 挂号
    guahaoHandle() {
      this.$emit("guahao");
    },
    // 关闭症状窗口
    closeHandle() {
      this.$emit("close");
    },
    // 获取症状分类列表
    async getSymptomList(buildId = this.buildInfo.buildId) {
      try {
        let res = await this.$apis.third.getSymptomList({
          buildId: buildId,
          limit: "1000",
          page: "1"
        });
        return JSON.parse(res.data);
      } catch (error) {
        console.log(error);
      }
    },
    // 获取症状详情
    async getSymptomdetail(detailId, buildId = this.buildInfo.buildId) {
      try {
        let res = await this.$apis.third.getSymptomdetail({
          buildId,
          detailId
        });
        let data = JSON.parse(res.data);
        this.symptomDetailList = data;
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    // 拼音搜索
    async pinyinSearch(search, buildId = this.buildInfo.buildId) {
      try {
        let res = await this.$apis.third.pinyinSearch({
          buildId,
          search
        });
        let data = res.data ? JSON.parse(res.data) : [];
        this.pinyinSearchList = data;
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    // 人形症状查询
    async queryPersonFace(
      personType,
      gender,
      faceType,
      humanPart,
      buildId = this.buildInfo.buildId
    ) {
      try {
        let res = await this.$apis.third.queryPersonFace({
          buildId,
          personType,
          gender,
          faceType,
          humanPart
        });
        let data = res.data;
        return data;
      } catch (error) {
        console.error(error);
      }
    },
    // 点击人形部位
    async clickPerson(index) {
      this.humanPart = parseInt(index);
      let group =
        String(this.personType) +
        String(this.gender) +
        String(this.faceType) +
        String(this.humanPart);
      // 如果之前已经查询过该部位，则直接返回数据
      if (this.personSymptomDataObj.hasOwnProperty(group)) {
        this.personSymptomData = this.personSymptomDataObj[group];
        if (!this.personSymptomData) {
          this.$message.info("暂无该症状数据");
        }
        console.log("返回缓存数据");
        return;
      }
      // 否则查询数据
      let res = await this.queryPersonFace(
        this.personType,
        this.gender,
        this.faceType,
        this.humanPart
      );
      this.personSymptomData = res || null;
      this.personSymptomDataObj[group] = res || null;
      if (!this.personSymptomData) {
        this.$message.info("暂无该症状数据");
      }
      console.log("查询数据");
    },
    // 切换人形
    changePerson(property, value) {
      if (this[property] === value) {
        return;
      }
      this[property] = value;
      this.personSymptomData = null;
    }
  }
};
</script>

<style scoped lang="scss">
.wrap-symptom {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: $color-opacity-regular;
  .close-icon {
    display: none;
  }
  //症状列表
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 68vh;
    transform: translate(-50%, -50%);
    background: url("/images/preloader/bg-symptom1.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    padding: 5px 10px 12px 8px;
    box-sizing: border-box;
  }
  .bg2 {
    background: url("/images/preloader/bg-symptom2.png") no-repeat;
    background-size: 100% 100%;
  }
  .symptom-left {
    width: 295px;
    color: $color-white;
    .title {
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      img {
        margin: 0 10px 0 0;
      }
    }
    .list-wrap {
      height: calc(100% - 220px);
      overflow: auto;
      .list {
        list-style: none;
      }
      li {
        font-size: 26px;
        height: 70px;
        line-height: 70px;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .active {
        background: #386998;
        color: #40e9ad;
        border-left: 5px solid #40e9ad;
      }
    }
    .btn-group {
      flex: 0 0 wrap;
      display: flex;
      height: 100px;
      align-items: center;
      justify-content: center;
      & > div {
        width: 100px;
        height: 40px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        border-radius: 50px;
        // margin: 0 40px 0 0;
        color: $color-white;
      }
      img {
        margin: 0 10px 0 0;
        width: 24px;
      }
    }
  }
  .symptom-middle {
    width: 1160px;
    padding: 40px 0 40px 0;
    display: flex;
    flex-direction: column;
    .content {
      height: 660px;
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      color: $color-white;
      font-size: 28px;
      // flex: 1;
      align-content: flex-start;
      height: 100%;
      width: 100%;
      overflow: auto;
    }
    li {
      width: 258px;
      height: 98px;
      line-height: 80px;
      box-sizing: border-box;
      padding: 5px 20px 10px 18px;
      margin: 0 16px 20px;
      text-align: center;
      background: url("/images/preloader/btn-bg1.png");
      background-size: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .btn-group {
      position: relative;
      display: flex;
      flex-direction: row-reverse;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        margin: 0 40px 0 0;
        color: $color-white;
      }
      .renxing-btn {
        position: absolute;
        left: 40px;
        top: 0;
        width: 250px;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
    .btn-group-top {
      position: relative;
      display: flex;
      padding-bottom: 40px;
      margin-left: 20px;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        margin: 0 40px 0 0;
        color: $color-white;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
  }
  .symptom-right {
    position: relative;
    width: 385px;
    margin: 40px 0 40px 0;
    border-left: 1px solid #618aaf;
    .title {
      font-size: 28px;
      color: $color-white;
      width: 306px;
      margin: 0 auto 40px;
      text-align: left;
    }
    .search-input {
      border: 1px solid #618aaf;
      border-radius: 10px;
      width: 306px;
      height: 50px;
      line-height: 50px;
      margin: 0 auto;
      text-align: left;
      color: $color-white;
      font-size: 26px;
      padding: 0 20px;
      box-sizing: border-box;
      background: transparent;
    }
    .letter-wrap {
      display: flex;
      flex-wrap: wrap;
      border: 1px solid #618aaf;
      border-radius: 10px;
      overflow: hidden;
      width: 306px;
      margin: 10px auto 0;
      .letter {
        width: 50px;
        height: 50px;
        line-height: 50px;
        border: 1px solid #618aaf;
        // box-sizing: border-box;
        margin: -1px 0 0 -1px;
        color: $color-white;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          background: #345b85;
        }
        img {
          margin: 0 10px 0 0;
        }
      }
    }
    .btn-group {
      display: flex;
      flex-direction: row-reverse;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      justify-content: center;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        color: $color-white;
      }
      .btn-right {
        display: none;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
  }
  .symptom-detail-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: $color-opacity-primary;
    z-index: 999999;
  }
  .symptom-detail {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1472px;
    height: 68vh;
    transform: translate(-50%, -50%);
    background: url("/images/preloader/bg-symptom3.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    padding: 45px 50px 52px 48px;
    box-sizing: border-box;
    flex-direction: column;
    text-align: left;
    color: $color-white;
    .title {
      font-size: 36px;
      line-height: 36px;
      margin: 0 0 20px 0;
      height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .content {
      height: calc(100% - 64px);
      width: 100%;
      font-size: 24px;
      padding-left: 20px;
      // text-indent: 2em;
    }
    .d-flex {
      display: flex;
      height: 100%;
    }
    .description {
      flex: 1;
      overflow: auto;
      line-height: 50px;
      font-size: 24px;
    }
    .step-info {
      width: 40%;
      height: 90%;
      padding: 36px 0 36px 36px;
      overflow-y: auto;
    }
    .step-block {
      width: 100%;
      height: 100%;
    }
    .step-item {
      position: relative;
      top: 0;
      left: 0;
      font-size: 24px;
      padding: 0 0 24px 30px;
      border-left: dashed 1px #ccc;
      &:last-child {
        border-left: none;
      }
      &-sort {
        background-color: #39597c;
        border: 1px solid #fff;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        line-height: 24px;
        padding: 2px;
        text-align: center;
        overflow: hidden;
        position: absolute;
        left: -19px;
        top: -2px;
      }
      &-title {
        // padding-top: 24px;
        margin-bottom: 10px;
      }
      &-content {
        display: inline-flex;
        align-items: center;
        padding: 12px 24px;
        border-radius: 10px;
        background-color: rgba(0, 0, 0, 0.2);
        margin-bottom: 10px;
      }
    }
    .step-item-content span {
      margin-right: 30px;
    }
    .btn-group {
      position: relative;
      display: flex;
      flex-direction: row-reverse;
      justify-content: center;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        color: $color-white;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
      .guahao {
        position: absolute;
        left: 0;
        top: 0;
        background: linear-gradient(to bottom, #40e9ad 0%, #03af6c 100%);
      }
    }
  }

  //人形部位
  .person-symptom {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 68vh;
    transform: translate(-50%, -50%);
    background: url("/images/preloader/bg-symptom4.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    padding: 5px 10px 12px 8px;
    box-sizing: border-box;
    &-left {
      width: 575px;
    }
    &-right {
      width: 880px;
      margin: 40px 0 40px 0;
      .btn-group {
        position: relative;
        display: flex;
        flex-direction: row-reverse;
        & > div {
          width: 180px;
          height: 60px;
          background: #3a6191;
          box-shadow: 0 0 10px $color-opacity-primary;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 26px;
          border-radius: 50px;
          margin: 0 40px 0 0;
          color: $color-white;
        }
        img {
          margin: 0 20px 0 0;
          width: 24px;
        }
        .btn-left {
          position: absolute;
          left: 40px;
          top: 0;
          width: 250px;
          img {
            width: 25px;
          }
        }
        .btn-right {
          img {
            width: 24px;
          }
        }
      }
    }
  }
}

// 人形部位
.person-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  .btn-group {
    width: 200px;
    height: 60px;
    line-height: 60px;
    display: flex;
    font-size: 26px;
    text-align: center;
    overflow: hidden;
    box-shadow: 0 0 10px $color-opacity-primary;
    border-radius: 50px;
    color: #fff;
    & > div {
      flex: 1;
      background: linear-gradient(to bottom, #426687 0%, #32587a 100%);
    }
    .active {
      background: #17da94;
      background: linear-gradient(to bottom, #38e8a9 0%, #03af6c 100%);
      &:first-child {
        border-radius: 50px 0 0 50px;
      }
      &:last-child {
        border-radius: 0 50px 50px 0;
      }
    }
  }
  .btn-group2 {
    display: flex;
    flex-direction: column;
    font-size: 26px;
    color: #fff;
    & > div {
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 50%;
      margin: 0 0 30px 0;
      background: linear-gradient(to bottom, #426687 0%, #32587a 100%);
      box-shadow: 0 0 10px $color-opacity-primary;
      &:last-child {
        margin: 0;
      }
    }
    .active {
      background: #17da94;
      background: linear-gradient(to bottom, #38e8a9 0%, #03af6c 100%);
      border: 1px solid #17da94;
    }
  }
  .btn1 {
    position: absolute;
    top: 30px;
    left: 30px;
    z-index: 10;
  }
  .btn2 {
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 10;
  }
  .btn3 {
    position: absolute;
    top: 200px;
    right: 30px;
    z-index: 10;
  }
  .person {
    height: 90%;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9;
    .wh {
      height: 90%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .wh70 {
      height: 70%;
    }
    .wh90 {
      height: 90%;
    }
    .cls-1 {
      fill: rgba(51, 140, 212, 0);
      // stroke: #fff;
      // stroke-width: 2px;
      &:hover {
        fill: rgba(228, 192, 32, 0);
      }
    }
  }
  .tip {
    position: absolute;
    bottom: 40px;
    left: 0;
    width: 100%;
    font-size: 16px;
    color: #fff;
  }
}
.symptomPop {
  height: calc(100% - 60px);
  padding: 20px 0;
  box-sizing: border-box;
  .content {
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
  }
  .symptom-wrap {
    margin: 0 0 20px 0;
    .symptom-cate {
      font-size: 36px;
      color: #fff;
      text-align: left;
      margin: 0 0 20px 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .symptom-list {
      display: flex;
      flex-wrap: wrap;
      color: $color-white;
      font-size: 28px;
      // flex: 1;
      align-content: flex-start;
      height: 100%;
      width: 100%;
      overflow: auto;
    }
    .symptom-li {
      width: 258px;
      height: 98px;
      line-height: 80px;
      box-sizing: border-box;
      padding: 5px 20px 10px 18px;
      margin: 0 17.5px 20px;
      text-align: center;
      background: url("/images/preloader/btn-bg1.png");
      background-size: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.el-button--primary {
  background-color: #03af6c; /* 将蓝色改为你想要的颜色 */
  border-color: #03af6c;
}
@media (orientation: portrait) {
  .wrap-symptom {
    .close-icon {
      display: block;
      position: absolute;
      top: -60px;
      right: 0;
      font-size: 38px;
      color: #ccc;
      width: 50px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      border-radius: 50%;
      border: 2px solid #ccc;
      padding: 0;
      font-weight: bold;
      box-sizing: border-box;
    }
    .container {
      height: 68vh;
      padding: 0;
      // background-size: auto 100%;
      background: rgba(46, 90, 141, 0.94);
      border-radius: 20px;
      .close-icon {
        display: block;
        position: absolute;
        top: -60px;
        right: 0;
        font-size: 38px;
        color: #ccc;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border-radius: 50%;
        border: 2px solid #ccc;
        padding: 0;
        font-weight: bold;
        box-sizing: border-box;
      }
    }
    .symptom-middle {
      background: #476f9b;
      border-radius: 0 20px 20px 0;
      .content {
        height: calc(100% - 620px);
      }
      .list {
        height: calc(100% - 620px);
        padding: 0;
      }
      .btn-group {
        display: none;
      }
      .btn-group-top {
        display: none;
      }
    }
    .symptom-left {
      .btn-group {
        & > div {
          width: 120px;
          height: 50px;
          font-size: 20px;
        }
      }
    }
    .symptom-right {
      padding: 20px;
      position: absolute;
      margin: 0;
      height: 600px;
      width: 1160px;
      bottom: 0;
      right: 0;
      display: block !important;
      border: 0;
      .title {
        text-align: center;
        margin: 0 auto 10px;
      }
      .search-input {
        width: 936px;
        height: 70px;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .letter-wrap {
        width: 936px;
        .letter {
          width: 70px;
          height: 70px;
          font-size: 30px;
          img {
            width: 20px;
          }
        }
      }
      .btn-group {
        position: absolute;
        right: 30px;
        left: auto;
        bottom: 40px;
        width: 200px;
        div:nth-of-type(1) {
          display: none;
        }
        .btn-right {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .person-wrap {
      .person {
        .wh70 {
          height: auto;
          width: 70%;
        }
        .wh90 {
          height: auto;
          width: 90%;
        }
      }
    }
    .person-symptom {
      background: rgba(46, 90, 141, 0.94);
      border-radius: 20px;
      padding: 0;
    }
    .person-symptom-right {
      background: #476f9b;
      margin: 0;
      border-radius: 0 20px 20px 0;
      padding: 40px 0 40px 0;
    }
    .tab-symptom {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 68vh;
      transform: translate(-50%, -50%);
      box-sizing: border-box;
      width: 1455px;
      z-index: 0;
      .tab-box {
        position: absolute;
        left: 0px;
        top: 50%;
        transform: translate(-100%, -50%);
        border-radius: 50px;
        overflow: hidden;
      }
      .tab-item {
        width: 60px;
        height: 250px;
        writing-mode: vertical-rl;
        background: linear-gradient(0.25turn, #426687 0%, #32587a 100%);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px;
      }
      .active {
        background: linear-gradient(0.25turn, #38e8a9 0%, #03af6c 100%);
      }
    }
    .person-symptom-right .btn-group .btn-left {
      display: none;
    }
    .person-wrap .tip {
      font-size: 30px;
    }
    .symptom-detail {
      background: #476f9b;
      border-radius: 20px;
      .content {
        height: calc(100% - 120px);
      }
    }
  }
}
</style>
